import React, { useCallback } from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import { COMMERCIAL_INVOICE_FORM } from "MODULES/shared/components/CommercialInvoice/Form/Form";
import { DISCREET } from "APP_ROOT/constants";
import classNames from "classnames";

const CommercialDiscreetButton = ({
  display,
  getCommercialInvoiceField,
  setCommercialInvoiceField
}) => {
  const setDiscreet = useCallback(() => {
    setCommercialInvoiceField(DISCREET, !getCommercialInvoiceField(DISCREET));
  });

  const discreetClass = classNames("btn btn-danger", {
    "btn-hollow": !getCommercialInvoiceField(DISCREET)
  });

  if (!display) return null;

  return (
    <span className={discreetClass} onClick={setDiscreet}>
      Discreet Commercial Invoice
    </span>
  );
};

CommercialDiscreetButton.propTypes = {
  display: T.bool.isRequired,
  getCommercialInvoiceField: T.func,
  setCommercialInvoiceField: T.func
};

export default connect(
  state => ({
    getCommercialInvoiceField: field =>
      formValueSelector(COMMERCIAL_INVOICE_FORM)(state, field)
  }),
  dispatch => ({
    setCommercialInvoiceField: (field, val) =>
      dispatch(change(COMMERCIAL_INVOICE_FORM, field, val))
  })
)(CommercialDiscreetButton);



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/CommercialDiscreetButton.jsx